import React from 'react';
import { Link, Table } from '@backstage/core-components';
import { makeStyles, TableContainer, TableHead } from '@material-ui/core';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import LinkIcon from '@material-ui/icons/Link';
import WarningIcon from '@material-ui/icons/Warning';
import { SEVERITY_COLORS } from '../../lib/utils.esm.js';
import { VulnerabilityOrder } from '../../types.esm.js';

const getVulnerabilityLink = (link) => link.split(" ")[0];
const columns = [
  {
    title: "Advisory",
    field: "name",
    render: (rowData) => {
      return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center" } }, rowData.Name, rowData.Link.trim().length > 0 ? /* @__PURE__ */ React.createElement(Link, { to: getVulnerabilityLink(rowData.Link) }, /* @__PURE__ */ React.createElement(LinkIcon, { style: { marginLeft: "0.5rem" } })) : null);
    },
    customSort: (a, b) => a.Name.localeCompare(b.Name, "en")
  },
  {
    title: "Severity",
    field: "Severity",
    customSort: (a, b) => {
      const severityA = VulnerabilityOrder[a.Severity];
      const severityB = VulnerabilityOrder[b.Severity];
      return severityA - severityB;
    },
    render: (rowData) => {
      return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center" } }, /* @__PURE__ */ React.createElement(
        WarningIcon,
        {
          htmlColor: SEVERITY_COLORS[rowData.Severity],
          style: {
            marginRight: "0.5rem"
          }
        }
      ), /* @__PURE__ */ React.createElement("span", null, rowData.Severity));
    }
  },
  {
    title: "Package Name",
    field: "PackageName",
    type: "string"
  },
  {
    title: "Current Version",
    field: "CurrentVersion",
    type: "string"
  },
  {
    title: "Fixed By",
    field: "FixedBy",
    render: (rowData) => {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, rowData.FixedBy.length > 0 ? /* @__PURE__ */ React.createElement("span", null, rowData.FixedBy) : "(None)");
    }
  }
];
const useStyles = makeStyles({
  link: {
    display: "flex",
    alignItems: "center"
  },
  linkText: {
    marginLeft: "0.5rem",
    fontSize: "1.1rem"
  },
  tableHead: {
    display: "flex",
    alignItems: "center",
    marginBottom: "1rem"
  }
});
const QuayTagDetails = ({
  layer,
  rootLink,
  digest
}) => {
  const classes = useStyles();
  const vulnerabilities = layer.Features.filter(
    (feat) => typeof feat.Vulnerabilities !== "undefined"
  ).map((feature) => {
    return feature.Vulnerabilities.map(
      (v) => {
        return {
          ...v,
          PackageName: feature.Name,
          CurrentVersion: feature.Version
        };
      }
    );
  }).flat().sort((a, b) => {
    const severityA = VulnerabilityOrder[a.Severity];
    const severityB = VulnerabilityOrder[b.Severity];
    return severityA - severityB;
  });
  return /* @__PURE__ */ React.createElement(TableContainer, null, /* @__PURE__ */ React.createElement(TableHead, { className: classes.tableHead }, /* @__PURE__ */ React.createElement(Link, { to: rootLink(), className: classes.link }, /* @__PURE__ */ React.createElement(KeyboardBackspaceIcon, null), /* @__PURE__ */ React.createElement("span", { className: classes.linkText }, "Back to repository"))), /* @__PURE__ */ React.createElement(
    Table,
    {
      title: `Vulnerabilities for ${digest.substring(0, 17)}`,
      data: vulnerabilities,
      columns
    }
  ));
};

export { QuayTagDetails, QuayTagDetails as default };
//# sourceMappingURL=component.esm.js.map
